export const releaseAnnouncementActionTypes = {
    STORE_ACTIVE_ANNOUNCEMENT: 'STORE_ACTIVE_ANNOUNCEMENT',
} as const;
